import { useLingui } from '@lingui/react'
import type { FC } from 'react'

import CategoryListMobileV1 from 'shared/experiments/components/NewSerp/CategoryList/CategoryListMobileV1'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { FACETS_LIMIT } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'
import { ProductFilterV1FilterCounter } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilterV1/ProductFilterV1FilterCounter/ProductFilterV1FilterCounter'

import './ProductFilterV1CategoryList.scss'

const modalId = 'product-filter-v1-category-list'

export const ProductFilterV1CategoryList: FC = () => {
  const { i18n } = useLingui()

  return (
    <div className="o-product-filter-v1-category-list">
      {/* @ts-ignore */}
      <ModalShowButton
        component={ButtonAsLink}
        name={modalId}
        modalId={modalId}
        neutral
      >
        <div className="l-flex o-product-filter-v1-category-list__item">
          <p className="u-no-margin l-flex__primary u-text-align--left u-font-weight--semi-bold o-product-filter-v1-category-list__text">
            {i18n._('general.label.categories')}{' '}
            <ProductFilterV1FilterCounter attribute="primaryCategory" />
          </p>
          <IconCaretRight />
        </div>
      </ModalShowButton>
      <Modal
        id={modalId}
        title={i18n._('general.label.categories')}
        isClientSideControlled
        fullScreen
      >
        <CategoryListMobileV1
          attribute="primaryCategory"
          // @ts-ignore
          label={i18n._('general.label.categories')}
          modalId={modalId}
          limit={FACETS_LIMIT}
          className="o-ProductFilter__item"
        />
      </Modal>
    </div>
  )
}
